export default __webpack_public_path__ + "static/salesCrm-db3fd3f1546851358a1b5af0056cfe78.png";